module.exports = __webpack_public_path__ + "img/anim_bg1.b594fbd7.gif";